export const TeamTypes = ['Werbung', 'Sponsoring', 'Zielgruppenkommunikation'];

export const TargetTypes = ['B2B', 'B2C'];

export type ViewType =
  | 'individual'
  | 'grouped'
  | 'kanban'
  | 'list'
  | 'grid_3'
  | 'grid_4'
  | 'grid_6'
  | 'grid_8'
  | 'selectColumns'
  | 'showGridViewSmall'
  | 'showGridViewLarge'
  | 'showGridViewSidebar'
  | 'showListView'
  | 'showGridView'
  | 'gridSize'
  | 'sortByAlphabetically'
  | 'sortByLastCreated'
  | 'scheduler'
  | 'month'
  | 'week';

export const SearchAssetsFieldPlaceholder = $localize`:@@searchFieldPlaceholder:Search assets...`;

export const LufthansaGroupID = '67d80341f77a6157b1847e60';
